var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckShield = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.527 5.126L12.527 0.126C12.224 -0.042 11.858 -0.042 11.555 0.126L2.55499 5.126C2.23799 5.303 2.04199 5.637 2.04199 6C2.04199 6.694 2.15599 23 12.042 23C21.928 23 22.042 6.694 22.042 6C22.042 5.637 21.845 5.303 21.527 5.126ZM12.38 16.816L7.29199 13L8.79199 11L11.703 13.184L15.982 6.338L18.102 7.663L12.38 16.816Z",
    fill: "#ffffff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-shield.83af8701a87ff37ab8fa1ed83cbbef0c.svg";